import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { borderGrey, darkPurple, dimGrey, lightGrey } from '../../../mainTheme';

interface Props {
  label: string;
  value: string | number;
  sub?: string;
  accent?: string;
  mocked?: boolean;
}

const KpiCard: React.FC<Props> = ({
  label,
  value,
  sub,
  accent = darkPurple,
  mocked,
}) => (
  <Paper
    elevation={0}
    sx={{
      border: `1px solid ${borderGrey}`,
      borderRadius: '16px',
      p: 2,
      height: '100%',
      borderLeft: `4px solid ${accent}`,
    }}
  >
    <Typography
      variant="caption"
      sx={{ color: dimGrey, textTransform: 'uppercase', letterSpacing: 0.4 }}
    >
      {label}
    </Typography>
    <Typography
      sx={{ fontSize: 30, fontWeight: 700, color: darkPurple, lineHeight: 1.2 }}
    >
      {value}
    </Typography>
    <Box minHeight={18}>
      {sub && (
        <Typography variant="caption" sx={{ color: lightGrey }}>
          {sub}
          {mocked ? ' • mock' : ''}
        </Typography>
      )}
    </Box>
  </Paper>
);

export default KpiCard;
